<template>
  <v-container fluid class="pa-0" id="menu">
    <!-- header -->
    <v-footer padless id="top_footer">
      <v-card class="flex" flat tile>
        <v-card-title class="background_color_d6f1ec">
          <v-spacer class="background_color_d6f1ec"></v-spacer>
          <div class="text-center text-caption text-sm-h6 text-lg-h5" style="word-break: break-word;">
            Free Ground Shipping on Orders Over $99 (Some Exclusions Apply)
            <!-- Free Ground Shipping on Eligible Items Over $99 -->
          </div>
          <v-spacer class="background_color_d6f1ec"></v-spacer>

          <div style="font-size: 15px; position: absolute; right: 20px;" @click="onClickMember" v-show="$enableMembership && $vuetify.breakpoint.mdAndUp">
            <v-icon medium color class="menu_icon">mdi-account</v-icon>
            {{ $t("menu.member") }}
          </div>
        </v-card-title>
      </v-card>
    </v-footer>

    <!-- menu for mobile view -->
    <div class="my_header" v-show="$vuetify.breakpoint.smAndDown && showMobileHeader">
      <v-row align="center">
        <!-- company icon -->
        <v-col cols="3" style="padding-left: 15px;">
          <img src="../assets/img/icon_logo_1.png" class="logo" @click="onCLickHome" />
        </v-col>
        <!-- search box -->
        <v-col cols="7">
          <wc-search-box style="padding-left: 5px;" :placeholder="$t('menu.search')" @search="onClickSearch" />
        </v-col>
        <!-- shopping cart -->
        <v-col cols="2" class style="padding-left: 5px;" v-show="$enableShoppingCart && showHeaderCart">
          <wc-tabbar-cart ref="cart" />
        </v-col>
      </v-row>
    </div>

    <!-- menu for desktop view -->
    <div class="my_header" v-show="$vuetify.breakpoint.mdAndUp && showDesktopHeader">
      <v-row align="center">
        <!-- company icon -->
        <v-col cols="2">
          <img src="../assets/img/icon_logo_2.png" class="logo" @click="onCLickHome" />
        </v-col>
        <!-- search box -->
        <v-col cols="9">
          <wc-search-box style="padding-left: 20px;" :placeholder="$t('menu.search')" @search="onClickSearch" />
        </v-col>
        <!-- shopping cart -->
        <v-col cols="1" v-show="$enableShoppingCart && showHeaderCart">
          <wc-tabbar-cart ref="cart" />
        </v-col>
      </v-row>
      <!-- classify navigation -->
      <v-tabs v-model="topTab" :optional="this.topTab == null" fixed-tabs center-active show-arrows>
        <v-tab v-show="$enableBrands" @click="onClickBrand">{{ $t("menu.brand") }}</v-tab>
        <v-tab v-for="(item, id) in topClassify" :key="id" @click="onClickTopClassify(item)">{{ item.Title }}</v-tab>
      </v-tabs>
    </div>

    <!-- common body for desktop and mobile view -->
    <div class="spacer"></div>
    <router-view></router-view>

    <!-- bottom nav bar for mobile view -->
    <van-tabbar v-model="active" fixed @change="onChangeSelection" class="footer-tabbar" v-show="$vuetify.breakpoint.smAndDown && showMobileFooterNav">
      <!-- absolute/fixed   light/dark  top/bottom left/right keyboard_arrow_up -->
      <v-fab-transition>
        <v-btn v-scroll="onScroll" v-show="showS2TopFAB" dark small fab absolute xtop right style="top: -60px;" color="primary" @click="toTop">
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-fab-transition>

      <div class="van-tabbar-item" v-show="curTab == 1">
        <v-icon large color="#55c4af">mdi-home</v-icon>
        <div class="van-tabbar-item__text">
          <b>{{ $t("menu.home") }}</b>
        </div>
      </div>
      <div class="van-tabbar-item" v-show="!(curTab == 1)" @click="onCLickHome">
        <v-icon large color>mdi-home</v-icon>
        <div class="van-tabbar-item__text" style="color: #238170;">
          <b>{{ $t("menu.home") }}</b>
        </div>
      </div>

      <div class="van-tabbar-item" v-show="$enableCategories && curTab == 2">
        <v-icon large color="#55c4af">mdi-shape</v-icon>
        <div class="van-tabbar-item__text">
          <b>{{ $t("menu.classify") }}</b>
        </div>
      </div>
      <div class="van-tabbar-item" v-show="$enableCategories && !(curTab == 2)" @click="onClickClassify">
        <v-icon large color>mdi-shape</v-icon>
        <div class="van-tabbar-item__text" style="color: #238170;">
          <b>{{ $t("menu.classify") }}</b>
        </div>
      </div>

      <div class="van-tabbar-item" v-show="$enableBrands && curTab == 3">
        <v-icon large color="#55c4af">mdi-tag-multiple</v-icon>
        <div class="van-tabbar-item__text">
          <b>{{ $t("menu.brand") }}</b>
        </div>
      </div>
      <div class="van-tabbar-item" v-show="$enableBrands && !(curTab == 3)" @click="onClickBrand">
        <v-icon large color>mdi-tag-multiple</v-icon>
        <div class="van-tabbar-item__text" style="color: #238170;">
          <b>{{ $t("menu.brand") }}</b>
        </div>
      </div>

      <div class="van-tabbar-item" v-show="$enableMembership && curTab == 4">
        <v-icon large color="#55c4af">mdi-account</v-icon>
        <div class="van-tabbar-item__text">
          <b>{{ $t("menu.member") }}</b>
        </div>
      </div>
      <div class="van-tabbar-item" v-show="$enableMembership && !(curTab == 4)" @click="onClickMember">
        <v-icon large color>mdi-account</v-icon>
        <div class="van-tabbar-item__text" style="color: #238170;">
          <b>{{ $t("menu.member") }}</b>
        </div>
      </div>

      <div class="van-tabbar-item" v-show="curTab == 0">
        <v-icon large color="#55c4af">mdi-information-outline</v-icon>
        <div class="van-tabbar-item__text">
          <b>{{ $t("menu.info") }}</b>
        </div>
      </div>

      <div class="van-tabbar-item" v-show="!(curTab == 0)" @click="onClickAppInfo">
        <v-icon large color>mdi-information-outline</v-icon>
        <div class="van-tabbar-item__text" style="color: #238170;">
          <b>{{ $t("menu.info") }}</b>
        </div>
      </div>
    </van-tabbar>

    <div class="spacer"></div>
    <!-- footer -->
    <!-- common footer for desktop and mobile view     margin-bottom: 60px;    -->
    <v-footer padless class="mb-5" v-show="($vuetify.breakpoint.mdAndUp && showDesktopFooter) || ($vuetify.breakpoint.smAndDown && showMobileFooter)">
      <v-card class="flex text-center mb-5" flat tile>
        <v-card-title class="background_color_d6f1ec">
          <v-row xalign="center">
            <v-col cols="12" class="mb-1" v-show="$vuetify.breakpoint.xs">
              <v-btn icon small href="https://mrsdigi.com">Powered by<v-img width="88" contain src="../assets/img/mrsdigibanner.png"></v-img></v-btn>
            </v-col>

            <v-col cols="4" md="4" v-show="$vuetify.breakpoint.smAndUp">
              <img src="../assets/img/privacy_guaranteed.png" style="width: 70px; padding-right: 10px;" />
              <img src="../assets/img/secure_payment.png" style="width: 70px; padding-right: 10px;" />
              <img src="../assets/img/mastercard.png" class="px-4" style="width: 70px;" />
              <img src="../assets/img/visa.png" class="px-4" style="width: 70px; " />
            </v-col>

            <v-col cols="12" sm="4" md="4" class="text-caption text-sm-subtitle-2 font-weight-thin">
              <strong class="d-inline text-break">&#169; 2023 BABYBRYAN, ALL RIGHTS RESERVED. </strong>
              <v-btn icon class="text-break ml-3" @click="onClickAppInfo" v-show="$vuetify.breakpoint.mdAndUp">
                <v-icon medium color class="menu_icon">mdi-information-outline</v-icon>
                <b>{{ $t("menu.info") }}</b>
              </v-btn>
            </v-col>

            <v-col cols="3" md="4" class="text-subtitle-2 font-weight-regular" v-show="$vuetify.breakpoint.smAndUp">
              <div class="d-inline">Follow us</div>
              <v-btn icon x-small href="http://fb.me/BabyBryanOfficial"> <v-icon>mdi-facebook</v-icon> </v-btn>
              <v-btn icon x-small href="https://www.instagram.com/babybryan_official/"> <v-icon>mdi-instagram</v-icon> </v-btn>
              <v-btn icon x-small @click="onClickEmail()"> <v-icon>mdi-email</v-icon> </v-btn>
            </v-col>

            <v-col cols="8" v-show="$vuetify.breakpoint.xs">
              <img src="../assets/img/privacy_guaranteed.png" style="width: 48px; padding-right: 8px;" />
              <img src="../assets/img/secure_payment.png" style="width: 48px; padding-right: 8px;" />
              <img src="../assets/img/mastercard.png" style="width: 35px; padding-right: 8px;" />
              <img src="../assets/img/visa.png" style="width: 35px; padding-right: 8px;" />
            </v-col>
            <v-col cols="4" class="text-caption font-weight-regular" v-show="$vuetify.breakpoint.xs">
              <v-btn icon x-small href="http://fb.me/BabyBryanOfficial"> <v-icon>mdi-facebook</v-icon> </v-btn>
              <v-btn icon x-small href="https://www.instagram.com/babybryan_official/"> <v-icon>mdi-instagram</v-icon> </v-btn>
              <v-btn icon x-small @click="onClickEmail()"> <v-icon>mdi-email</v-icon> </v-btn>
            </v-col>
            <v-col cols="12" class="mb-1" v-show="$vuetify.breakpoint.smAndUp">
              <v-btn icon small href="https://mrsdigi.com">Powered by <v-img class="mx-2" width="88" contain src="../assets/img/mrsdigibanner.png"></v-img></v-btn> 
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-footer>

    <van-popup v-model="popupHints" position="bottom" class="background_color_d6f1ec" round @closed="onCloseHints">
      <h3 class="text-center" style="padding: 10px; padding-bottom: 0px;">Add Baby Bryan to home screen!</h3>
      <img src="../assets/img/icon_logo_1.png" class="logo" @click="onCLickHome" />
      <div>
        <ul class="text-center">
          <li style="padding: 2px;">
            1. Click
            <v-icon size="30px" style="top: -5px;">mdi-export-variant</v-icon>
          </li>
          <li style="padding: 2px;">
            2. Click "Add to home screen"
            <v-icon size="30px" style="top: -3px;">mdi-plus-box-outline</v-icon>
          </li>
          <li style="padding: 2px;">3. Click "Add"</li>
        </ul>

        <v-layout justify-center>
          <v-checkbox class="align-center justify-center" v-model="dontShowPopup" label="Do not show this again"></v-checkbox>
        </v-layout>
      </div>
    </van-popup>
  </v-container>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "home",
  data() {
    return {
      curTab: 1,
      active: parseInt(localStorage.getItem("activeBar")),
      popupHints: false,
      dontShowPopup: false,
      showS2TopFAB: false, // scroll to top floating action button
    };
  },
  // ------------------------------------------------------------------------
  computed: {
    checkPopupHints() {
      return this.$store.state.checkPopupHints;
    },
    member() {
      return this.$store.state.member;
    },
    pageMeta() {
      return this.$router.currentRoute.meta;
    },
    showDesktopHeader() {
      return !(this.pageMeta && this.pageMeta.hideDesktopHeader);
    },
    showMobileHeader() {
      return !(this.pageMeta && this.pageMeta.hideMobileHeader);
    },
    showHeaderCart() {
      return !(this.pageMeta && this.pageMeta.hideHeaderCart);
    },
    showDesktopFooter() {
      return !(this.pageMeta && this.pageMeta.hideDesktopFooter);
    },
    showMobileFooter() {
      return !(this.pageMeta && this.pageMeta.hideMobileFooter);
    },
    showMobileFooterNav() {
      return !(this.pageMeta && this.pageMeta.hideMobileFooterNav);
    },
    topClassify() {
      return this.$store.state.topClassify;
    },
    topTab: {
      get() {
        return this.$store.state.curTopTab;
      },
      set(value) {
        return this.$store.commit("curTopTab", value);
      },
    },
  },
  // ------------------------------------------------------------------------
  mounted() {
    // Checks if should display install hints notification:
    if (this.checkPopupHints) {
      this.$store.commit("checkPopupHints", false);
      if (this.$store.getters.isIosWebBased) {
        var hideHint = localStorage.getItem("hideShortcutHints");
        if (hideHint == null) this.popupHints = true;
      }
    }

    this.getTopClassify();

    window.addEventListener("scroll", this.handleScroll);
  },
  // ------------------------------------------------------------------------
  created() { },
  // ------------------------------------------------------------------------
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  // ------------------------------------------------------------------------
  methods: {
    // ------------------------------------------------------------------------ handleScroll
    handleScroll(event) {
      var navbar = document.getElementById("my_header_desktop");
      var navbar_mobile = document.getElementById("my_header_mobile");
      var top_footer = document.getElementById("top_footer");

      if (navbar != null && top_footer != null) {
        var sticky = navbar.offsetTop + top_footer.offsetHeight;

        if (window.pageYOffset >= sticky - 50) {
          navbar.classList.add("sticky");
        } else {
          navbar.classList.remove("sticky");
        }
      }

      if (navbar_mobile != null && top_footer != null) {
        var sticky_mobile = navbar_mobile.offsetTop + top_footer.offsetHeight;

        if (window.pageYOffset >= sticky_mobile - 50) {
          navbar_mobile.classList.add("sticky");
        } else {
          navbar_mobile.classList.remove("sticky");
        }
      }
    },
    // ------------------------------------------------------------------------ onScroll
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.showS2TopFAB = top > 20;
    },
    // ------------------------------------------------------------------------ toTop
    toTop() {
      this.$vuetify.goTo(0);
    },
    // ------------------------------------------------------------------------ getTopClassify
    getTopClassify() {
      if (this.topClassify.length == 0) {
        let $this = this;
        let obj = {
          AppVersion: this.$version,
          language: localStorage.getItem("lang"),
        };
        $this.$ajax2
          .post("GetCategories", obj, $this.$ajaxHeader)
          .then(function (rpdata) {
            if (rpdata.data.meta.code == "200") {
              for (let i = 0; i < rpdata.data.data.length; i++) {
                rpdata.data.data[i].index = i;
              }
              $this.$store.commit("topClassify", rpdata.data.data);
            }
          })
          .catch(function (err) { }); // eslint-disable-line
      }
    },
    // ------------------------------------------------------------------------ onClickTopClassify
    onClickTopClassify(data) {
      if (this.$router.currentRoute.name !== "classifyList" || this.$router.currentRoute.params.code != data.Id) {
        this.$router.push({ name: "classifyList", params: { code: data.Id } });
      }
    },
    // ------------------------------------------------------------------------ onClickSearch
    onClickSearch(data) {
      if (data != "") {
        this.$store.commit("productList", { text: data, routeBack: true });
        //this.$store.commit("incRouteCount");
        if (this.$router.currentRoute.name != "productList") {
          this.$router.push({ name: "productList" });
        }
      }
    },
    // ------------------------------------------------------------------------ onChangeSelection
    onChangeSelection(active) {
      localStorage.setItem("activeBar", active);
    },
    // ------------------------------------------------------------------------ onClickAppInfo
    onClickAppInfo() {
      this.curTab = 0;
      this.$router.push({ name: "aboutUs" });
    },
    // ------------------------------------------------------------------------ onCLickHome
    onCLickHome() {
      if (this.$router.history.current.name !== "home") {
        this.curTab = 1;
        this.$router.push({ name: "home" });
      }
    },
    // ------------------------------------------------------------------------ onClickClassify
    onClickClassify() {
      if (this.$router.currentRoute.name !== "classifyList") {
        this.curTab = 2;
        this.$router.push({ name: "classifyList" });
      }
    },
    // ------------------------------------------------------------------------ onClickBrand
    onClickBrand() {
      this.topTab = 0;
      if (this.$router.currentRoute.name !== "brandList") {
        this.curTab = 3;
        this.$router.push({ name: "brandList" });
      }
    },
    // ------------------------------------------------------------------------ onClickMember
    onClickMember() {
      this.curTab = 4;
      this.$router.push({ name: "member" });
      /*
      if (this.member.SessionToken) {
        this.$router.push({ name: "member" });
      } else {
        this.$router.push({ name: "login" });
      }
      */
    },
    // ------------------------------------------------------------------------ onClickEmail
    onClickEmail() {
      navigator.clipboard.writeText("info@babybryan.ca");
      Dialog.alert({
        title: "info@babybryan.ca",
        message: "email address copied to clipboard",
      });
    },
    // ------------------------------------------------------------------------ onCloseHints
    onCloseHints() {
      if (this.dontShowPopup == true) {
        localStorage.setItem("hideShortcutHints", true);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu_icon {
  margin-bottom: 2px;
}

.my_header {
  box-shadow: 0px 2px 10px lightgrey;
  z-index: 99;
  background-color: white;

  /* height: calc(44px + env(safe-area-inset-top)); */
  /* padding-top: env(safe-area-inset-top);   */
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  padding-top: env(safe-area-inset-top);
}

.spacer {
  height: 10px;
  background-color: #f4f4f4;
}

/* .mobile_footer {
  margin-bottom: 60px;
}
.browser_footer {
  margin-bottom: 0px;
} */
.logo {
  /* width: 90%; */
  height: 44px;
  display: block;
  margin: auto;
}

.footer-tabbar {
  box-shadow: 0px 2px 10px lightgrey;
  padding-top: 5px;
  /* padding-bottom: 5px; */
  z-index: 99;
  padding-bottom: calc(5px + env(safe-area-inset-bottom));
}

.moving-text:hover {
  animation-play-state: paused;
}

/* The animation */
@keyframes marquee {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

/* media query to enable animation for only those who want it */
@media (prefers-reduced-motion: no-preference) {
  .moving-text {
    white-space: nowrap;
    animation: marquee 15s linear infinite;
  }
}
</style>
